import { Component, OnInit } from '@angular/core';
import { CareerService } from './../../../services/career.service';
import { EnquiriesService } from './../../../services/enquiries.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppConfig } from './../../../config/app-config';
import { FileSection, FileType, FileData } from './../../../models/fileData';
import { SafeHtml, DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { FileService } from './../../../services/file.service';

@Component({
  selector: 'app-apply',
  templateUrl: './apply.component.html',
  styleUrls: ['./apply.component.css']
})
export class ApplyComponent implements OnInit {

  CareerForm$: FormGroup;

  Career$: any = {
    'id': 0,
    'title': '',
    'accountability': '',
    'mandate': '',
    'description': '',
    'location': '',
    'employmentType': '',
    'grade': ''
  };

  ResultMessage$ = '';

  submitted: boolean = false;
  pageErrors: boolean = false;

  uploadedFiles: any[];

  captchaInvalid: boolean = true;

  constructor(
    private careerService: CareerService,
    private route: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private enquiriesService: EnquiriesService,
    private formBuilder: FormBuilder,
    private fileService: FileService) {
  }

  resolved(captchaResponse: string) {
    if (captchaResponse == null) {
      this.captchaInvalid = true;
    }
    else {
      this.captchaInvalid = false;
    }
  }

  get f() { return this.CareerForm$.controls; }

  ngOnInit() {
    this.CareerForm$ = this.formBuilder.group({
      id: [0, Validators.required],
      name: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,9}$")]],
      phoneNumber: ['', Validators.required],
      attachFile: null,
      recaptchaReactive: null
    });
  }

  ngAfterContentInit() {
    this.loadCareer();
  }

  loadCareer() {
    this.route.queryParams.subscribe((params) => {
      let careerId = +params['careerId'];

      this.careerService.getCareerArticle(careerId).subscribe((response) => {

        var currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS');

        if (response.applicationEndDate >= currentDate) {
          this.Career$ = response;
          this.Career$.accountability = this.sanitizer.bypassSecurityTrustHtml(response.accountability);
          this.Career$.mandate = this.sanitizer.bypassSecurityTrustHtml(response.mandate);
          this.Career$.description = this.sanitizer.bypassSecurityTrustHtml(response.description);

          //get location text          
          this.careerService.getCareerLocationsList().subscribe((response) => {
            this.Career$.location = response.find(x => x.id == this.Career$.locationId).title;
          }, (error) => {
            console.log(error);
          });
        }
        else {
          this.Career$ = {
            'id': 0,
            'title': '',
            'accountability': '',
            'mandate': '',
            'description': '',
            'location': '',
            'employmentType': '',
            'grade': ''
          };
        }
      }, (error) => {
        console.log(error);
      });

    });
  }

  sendEnquiry() {

    this.ResultMessage$ = "Submitting, please wait...";

    this.submitted = true;
    this.pageErrors = false;

    if (this.CareerForm$.invalid) {
      this.pageErrors = true;
      this.ResultMessage$ = 'One or more fields are invalid.';
      return;
    }

    if (this.captchaInvalid == true) {
      this.pageErrors = true;
      this.ResultMessage$ = "Please complete the captcha";
      return;
    }

    var currentDate = new Date(this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss.SSS'));

    let enquiry = {
      "id": 0,
      "SectionId": 6,
      "DateAdded": currentDate,
      "EnquiryProperties": []
    };

    enquiry.EnquiryProperties.push({ "key": "careerVacancyTitle", "value": this.Career$.title });
    enquiry.EnquiryProperties.push({ "key": "name", "value": this.CareerForm$.controls.name.value });
    enquiry.EnquiryProperties.push({ "key": "emailAddress", "value": this.CareerForm$.controls.emailAddress.value });
    enquiry.EnquiryProperties.push({ "key": "phoneNumber", "value": this.CareerForm$.controls.phoneNumber.value });
    enquiry.EnquiryProperties.push({ "key": "subject", "value": "Career Vacancy" });
    enquiry.EnquiryProperties.push({ "key": "attachedFile", "value": (this.uploadedFiles != null).toString() });

    this.enquiriesService.saveEnquiry(enquiry).subscribe((response) => {
      var result = response as any;

      this.saveFiles(+result.id);


      this.ResultMessage$ = "Your application has been sent!";

      this.CareerForm$.reset();
      //this.EnquiryData$.attachFile.

      Object.keys(this.CareerForm$.controls).forEach(key => {
        this.CareerForm$.get(key).setErrors(null);
      });
      //this.EnquiryData$.controls.attachFile.value = '';
      //this.EnquiryData$.controls.attachFile = null;
      //$("#lbFileName").text("Choose file");
      this.CareerForm$.controls.recaptchaReactive = null;




    }, (error) => {
      this.ResultMessage$ = "An error occurred. Please try again later.";
      console.log(error);
    })
  }

  uploadFile(event) {
    this.uploadedFiles = event.target.files;
    console.log(this.uploadedFiles);
  }

  saveFiles(linkedId: number) {

    if (this.uploadedFiles == null) {
      return;
    }

    this.fileService.upload(this.uploadedFiles, FileSection.CareerApply, FileType.Document, linkedId).subscribe(event => {

    });
  }

}
